import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

@Injectable()

export class AuthInterceptor implements HttpInterceptor {
  
  getToken() {
    const data = localStorage.getItem("token");
    return (data ? data : null);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(req.urlWithParams.search("fetch-certificate") < 0 && req.urlWithParams.search('chat-bot.harappa.education') < 0 ){
      req = req.clone({
        setHeaders: {
          'Authorization': `${this.getToken()}`
        },
      });
    }
    return next.handle(req);
  }
}